import { useState, useEffect, useContext } from "react";
import { ThemeContext } from "../Helper/Context";
import Validation from "./Validation";
import useFetch from "./useFetch";

const Directdebit = ({ slot, hidePopup, closePopup, handleBack }) => {
  const { setShowSignin, mainState, setMainState, setShowLoader } = useContext(ThemeContext);
  const [{ response }, dofetch] = useFetch();
  const [apiName, setApiName] = useState(null);
  const [errors, setErrors] = useState({ errors: true });
  const [apiErrors, setApiErrors] = useState(false);
  const [ContractID, setContractID] = useState(false);
  const [formFields, setFormFields] = useState({
    accountNumber: {
      value: "",
      required: true,
      type: "accountnumber",
    },
    countryCode: {
      value: "AU",
      required: true,
      type: "text",
    },
    bankCode: {
      value: "",
      required: true,
      type: "bankcode",
    },
    ownerName: {
      value: "",
      required: true,
      type: "onwername",
    },
    street: {
      value: "",
      required: false,
      type: "text",
    },
    postCode: {
      value: "",
      required: false,
      type: "text",
    },
    city: {
      value: "",
      required: false,
      type: "text",
    },
  });

  const handleChange = (e) => {
    setFormFields((prevState) => ({
      ...prevState,
      [e.target.name]: {
        ...prevState[e.target.name],
        value: e.target.value,
      },
    }));
  };

  const handlePaynow = (e) => {
    e.preventDefault();
    setErrors(Validation(formFields));
  };
  const handleEnrollmentFetch = () => {
    let enrollmentData = {
      memberId: slot.selectedChild.id,
      groupId: slot.groupId,
      startDate: slot.startDate.split('T')[0],
      endDate: null,
      forceEnrollment: true,
      enrollmentOptionId: 2,
      setRequiredActivityLevel: true,
      notifyMember: true,
    };

    setApiName("EnrollMemberToGroup");
    dofetch(mainState.fetchURL, "EnrollMemberToGroup", "EnrollMemberToGroup.post.odata", "", JSON.stringify(enrollmentData));
  };

  const handleDirectDebitFetch = (contract) => {
    let directDebit = {
      memberId: mainState.user.userId,
      accountNumber: formFields.accountNumber.value,
      countryCode: formFields.countryCode.value,
      bankCode: formFields.bankCode.value,
      ownerName: formFields.ownerName.value,
      street: formFields.street.value,
      postalCode: mainState.user.address.postalCode,
      city: mainState.user.address.city,
      contractId: contract,
      setAsDefault: true,
    };

    console.log(directDebit);

    setApiName("AddDirectDebitPaymentMethod");
    dofetch(mainState.fetchURL, "AddDirectDebitPaymentMethod", "AddDirectDebitPaymentMethod.post.odata", JSON.stringify(directDebit), "");
  };

  const AttachPayment = (paymentID, contractID) => {
    let objecttoSend = {
      memberPaymentSourceId: parseInt(paymentID),
      contractsIds: [contractID],
    };
    // dofetch(mainState.fetchURL, 'AssignPaymentSource', 'AssignPaymentSource.post.odata', JSON.stringify(objecttoSend), true);
    dofetch(mainState.fetchURL, "AssignPaymentSource", "AssignPaymentSource.post.odata", "", JSON.stringify(objecttoSend), true);

    setShowLoader(false);
  };
  async function fetchData(url, endpointname, internalcall, body, urlparams = "") {
    setShowLoader(true);

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "CMSPreferredCulture=en-AU");
    let bodyData = JSON.stringify({
      integrationcode: "PERFECTGYMAPI",
      endpointname: endpointname,
      internalcall: internalcall,
      useheadervariables: true,
      urlparams: urlparams,
      body: body,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: bodyData,
      redirect: "follow",
    };

    // console.log(bodyData);
    console.log(requestOptions);
    return await fetch(url, requestOptions)
      .then((response) => {
        console.log(response);
        return response.json();
      })
      .then((result) => {
        setShowLoader(false);

        return result;
      })
      .catch((error) => {
        console.log(error);
        setShowLoader(false);
        setErrors(error);
      });
  }
  // useEffect(() => {
  //     console.log(response);
  //     if (!errors) {
  //         setErrors(true);
  //         handleEnrollmentFetch();

  //     }
  //     if (response) {
  //         if (apiName === "EnrollMemberToGroup") {
  //             setShowLoader(false);
  //             if (response.errors) {
  //                 if(response.errors.length > 0 && response.errors[0].message === "Already signed up for this group"){
  //                     handleDirectDebitFetch(ContractID)
  //                 }else{
  //                     setApiErrors(response.errors[0].message)
  //                 }

  //             } else {
  //                 setContractID(response.contractId)
  //                 setApiErrors(false)

  //             }
  //         } else if (apiName === "AddDirectDebitPaymentMethod") {
  //             setShowLoader(false);
  //             if (response.errors) {
  //                 console.log(response.errors);
  //                 setApiErrors(response.errors[0].message)
  //             } else {
  //                 console.log(response);
  //                 setApiErrors(false)
  //                 if(!ContractID){
  //                     AttachPayment(response.paymentSourceId, ContractID)
  //                 }

  //                 localStorage.setItem('childDetails', JSON.stringify(slot));
  //                 setMainState({
  //                     ...mainState,
  //                     section: 'enrolment',
  //                     isLoggedIn: true,
  //                     showVerification: false,
  //                     bookedSlot: slot,
  //                     ContractID: ContractID
  //                 })
  //             }
  //         }
  //     }

  // }, [errors, response]);

  useEffect(() => {
    async function fetching() {
      try {
        if (!errors) {
          let enrollmentData = {
            memberId: slot.selectedChild.id,
            groupId: slot.groupId,
            startDate: slot.startDate.split('T')[0],
            endDate: null,
            forceEnrollment: true,
            enrollmentOptionId: 2,
            setRequiredActivityLevel: true,
            notifyMember: true,
          };

          setApiName("EnrollMemberToGroup");
          let result = await fetchData(
            mainState.fetchURL,
            "EnrollMemberToGroup",
            "EnrollMemberToGroup.post.odata",
            JSON.stringify(enrollmentData),
            ""
          );

          if (result) {
            if (result.contractId !== undefined) {
              setContractID(result.contractId);
            }

            let directDebit = {
              memberId: mainState.user.userId,
              accountNumber: formFields.accountNumber.value,
              countryCode: formFields.countryCode.value,
              bankCode: formFields.bankCode.value,
              ownerName: formFields.ownerName.value,
              street: formFields.street.value,
              postalCode: mainState.user.address.postalCode,
              city: mainState.user.address.city,
              contractId: result.contractId ? result.contractId : ContractID,
              setAsDefault: true,
            };
            let ddb = await fetchData(
              mainState.fetchURL,
              "AddDirectDebitPaymentMethod",
              "AddDirectDebitPaymentMethod.post.odata",
              JSON.stringify(directDebit),
              ""
            );
            if (ddb) {
              let objecttoSend = {
                memberPaymentSourceId: parseInt(ddb.paymentSourceId),
                contractsIds: [result.contractId ? result.contractId : ContractID],
              };
              //   let AttachPayment = dofetch(                mainState.fetchURL,
              //     "AssignPaymentSource",
              //     "AssignPaymentSource.post.odata",
              //     JSON.stringify(objecttoSend),
              //     true,
              //     ""
              //   );

              let AttachPayment = dofetch(
                mainState.fetchURL,
                "AssignPaymentSource",
                "AssignPaymentSource.post.odata",
                "",
                JSON.stringify(objecttoSend),
                true
              );

              localStorage.setItem("childDetails", JSON.stringify(slot));
              setMainState({
                ...mainState,
                section: "enrolment",
                isLoggedIn: true,
                showVerification: false,
                bookedSlot: slot,
                ContractID: result.contractId ? result.contractId : ContractID,
              });
            }
          }
        }
      } catch (error) {
        setShowLoader(false);
        setApiErrors(error);
      }
    }
    fetching();
  }, [errors]);

  // console.log(apiErrors);
  return (
    <div
      className="perfectgym-popup"
      onClick={(e) => {
        hidePopup(e);
      }}
    >
      <div className="popup-content">
        <div className="closebtn" onClick={(e) => handleBack(e)}>
          <i className="fal fa-times"></i>
        </div>
        <h2>Direct debit payment</h2>
        {apiErrors && <p className="Error">{apiErrors}</p>}

        <div className="form">
          <div className="form-row">
            <div className="form-element">
              <label className="EditingFormLabel" htmlFor="accountNumber">
                Account number*
              </label>
              <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                <input
                  type="text"
                  className="form-control"
                  id="accountNumber"
                  name="accountNumber"
                  placeholder="Type your account number"
                  value={formFields.accountNumber.value}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              {errors.accountNumber && <span className="EditingFormErrorLabel">Account number must be only numbers with max of 9 digits</span>}
            </div>
          </div>
          {/* <div className="form-row">
                        <div className="form-element">
                            <label className="EditingFormLabel" htmlFor="countryCode">Country Code*</label>
                            <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                                <input type="text" className="form-control" id="countryCode" name="countryCode" placeholder="Type the country code"
                                    value={formFields.countryCode.value}
                                    onChange={e => handleChange(e)} />
                            </div>
                            {errors.countryCode &&
                                <span className="EditingFormErrorLabel">Bank code must be 2 characters</span>
                            }
                        </div>
                    </div> */}
          <div className="form-row">
            <div className="form-element">
              <label className="EditingFormLabel" htmlFor="countryCode">
                Country Code*
              </label>
              <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                <select id="countryCode" name="countryCode" value={formFields.countryCode.value} onChange={(e) => handleChange(e)}>
                  <option value="AU">Australia (AU)</option>
                </select>
              </div>
              {errors.countryCode && <span className="EditingFormErrorLabel">Please select country code</span>}
            </div>
          </div>
          <div className="form-row">
            <div className="form-element">
              <label className="EditingFormLabel" htmlFor="bankCode">
                Bank Code*
              </label>
              <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                <input
                  type="text"
                  className="form-control"
                  id="bankCode"
                  name="bankCode"
                  placeholder="Type the bank code"
                  value={formFields.bankCode.value}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              {errors.bankCode && <span className="EditingFormErrorLabel">Country code must be 6 digits and only numbers</span>}
            </div>
          </div>
          <div className="form-row">
            <div className="form-element">
              <label className="EditingFormLabel" htmlFor="ownerName">
                Bank owner name*
              </label>
              <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                <input
                  type="text"
                  className="form-control"
                  id="ownerName"
                  name="ownerName"
                  placeholder="Type the bank owner name"
                  value={formFields.ownerName.value}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              {errors.ownerName && <span className="EditingFormErrorLabel">Owner name must be minmum 4 characters</span>}
            </div>
          </div>
          {/* <h3>Address details:</h3>
                    <div className="form-row">
                        <div className="form-element">
                            <label className="EditingFormLabel" htmlFor="street">Street</label>
                            <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                                <input type="text" className="form-control" id="street" name="street" placeholder="Type the street"
                                    value={formFields.street.value}
                                    onChange={e => handleChange(e)} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-element">
                            <label className="EditingFormLabel" htmlFor="postCode">Post Code</label>
                            <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                                <input type="text" className="form-control" id="postCode" name="postCode" placeholder="Type the post code"
                                    value={formFields.postCode.value}
                                    onChange={e => handleChange(e)} />
                            </div>
                            {errors.postCode &&
                                <span className="EditingFormErrorLabel">Please enter post code</span>
                            }
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-element">
                            <label className="EditingFormLabel" htmlFor="city">City</label>
                            <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                                <input type="text" className="form-control" id="city" name="city" placeholder="Type the city"
                                    value={formFields.city.value}
                                    onChange={e => handleChange(e)} />
                            </div>
                            {errors.city &&
                                <span className="EditingFormErrorLabel">Please enter the city</span>
                            }
                        </div>
                    </div> */}

          <div className="form-row form-row-submit">
            <div className="form-element">
              <div className="btn-wrapper">
                <button className="FormButton btn" value="Done" onClick={(e) => handlePaynow(e)}>
                  Pay now
                </button>
                <button className="btn btn-border" onClick={(e) => handleBack(e)}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="btn-wrapper">
                    <button className="btn btn-border" onClick={(e) => closePopup(e)}>back</button>
                    <button className="btn" onClick={e => handlePaynow()}>Pay now</button>
                </div> */}
      </div>
    </div>
  );
};
export default Directdebit;
